export default __webpack_public_path__ + "static/media/default.7fccaef6971140a55f1834d27d21e9d5.png";